module.exports = __webpack_public_path__ + "assets/img/feature_03.86517bc7.png";